import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {
    Reservation
} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import {
    AgeCategory
} from "crqlar-react-common/dist/models/ageCategory/ageCategory.model";
import ReservationPreviewCardContent from "./ReservationPreviewCardContent";

export interface ReservationPreviewData {
    reservation: Reservation;
    profiles: Profile[];
    accommodationResources?: Resource[];
    ageCategories?: AgeCategory[];
    accommodationServiceName?: string;
    sourceTableName?: string;
    targetTableName?: string;
}

interface Props {
    data: ReservationPreviewData;
}

const ReservationPreviewCard: React.FC<Props> = ({data}) => {
    return (
        <ReservationPreviewCardContent
            reservation={data.reservation}
            profiles={data.profiles}
            accommodationResources={data.accommodationResources}
            ageCategories={data.ageCategories}
            accommodationServiceName={data.accommodationServiceName}
            sourceTableName={data.sourceTableName}
            targetTableName={data.targetTableName}
        />
    );
};

export default ReservationPreviewCard;
